module.exports = "https://www.gc-pro.gnp.com.mx/c9f15db08ffa16cc6ff055006edb5c5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-instagram.svg
// module id = 1831
// module chunks = 0